<template>
  <div class="profile-container">
    <div class="content-container">
      <slot></slot>
    </div>
    <div class="profile-info">
      <div class="profile-details">
        <div class="progress-container">
          <span
            v-if="progress !== undefined"
            class="progress-circle"
            :style="{ backgroundColor: getTrackingColor(progress) }"
          >
            {{ progress }}
          </span>
          <span class="name">{{ name }}</span>
        </div>
        <div v-if="formattedPhone" class="contact-item">
          <i class="fas fa-phone-alt blue-icon"></i>
          <span>{{ formattedPhone }}</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope blue-icon"></i>
          <span>{{ email }}</span>
        </div>
        <hilo-button
          v-if="lastFlight !== undefined"
          styleType="grey"
          label="View Last Flight"
          @click="lastFlight"
        />
        <hilo-button
          v-if="userId"
          styleType="grey"
          label="Notes"
          @click="() => (showNotesModal = true)"
        />
      </div>
    </div>
    <NotesModal
      v-if="showNotesModal && userId"
      :isVisible="showNotesModal"
      :targetUserId="userId"
      :targetName="name"
      noteTypeName="Profile"
      bottomRight
      @close="() => (showNotesModal = false)"
    />
  </div>
</template>

<script>
import HiloButton from "./HiloButton.vue";
import NotesModal from "@/components/HiloComponents/NotesModalOld.vue";
import { getTrackingColor } from "@/util/gradesAndTrackingColors";

export default {
  components: { NotesModal, HiloButton },
  props: {
    name: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: false,
    },
    email: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: false,
    },
    progress: {
      type: Number,
      required: false,
    },
    lastFlight: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      showNotesModal: false,
    };
  },
  computed: {
    formattedPhone() {
      if (!this.phone) return "";
      const phone = this.phone.replace(/\D/g, "");
      const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : this.phone;
    },
  },
  methods: { getTrackingColor },
};
</script>


<style scoped>
.profile-container {
  display: flex;
  flex-direction: column;
  /* height: 88vh; */
}

.content-container {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 50px;
}

.profile-info {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: black;
  color: white;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 5vh;
  margin-left: -20px;
}

.profile-details {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;
}

.name {
  font-size: 18px;
  font-weight: bold;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.blue-icon {
  color: #1e90ff;
  font-size: 14px;
}

.progress-circle {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: white;
  margin-right: 12px;
}
</style>
